var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserUnCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52272 6.72724C7.30305 6.50757 6.94689 6.50757 6.72722 6.72724C6.50755 6.94691 6.50755 7.30306 6.72722 7.52272L8.20446 9L6.72724 10.4773C6.50757 10.6969 6.50757 11.053 6.72724 11.2727C6.9469 11.4924 7.30306 11.4924 7.52272 11.2727L8.99999 9.79552L10.4772 11.2727C10.6969 11.4924 11.053 11.4924 11.2727 11.2727C11.4924 11.053 11.4924 10.6969 11.2727 10.4772L9.79544 9L11.2727 7.52272C11.4924 7.30308 11.4924 6.94693 11.2727 6.72726C11.053 6.50758 10.6969 6.50758 10.4772 6.72726L8.99999 8.20447L7.52272 6.72724Z",
    fill: "#FA3333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375ZM2.0625 9C2.0625 5.16853 5.16853 2.0625 9 2.0625C12.8314 2.0625 15.9375 5.16853 15.9375 9C15.9375 12.8314 12.8314 15.9375 9 15.9375C5.16853 15.9375 2.0625 12.8314 2.0625 9Z",
    fill: "#FA3333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserUnCheck);
export default __webpack_public_path__ + "static/media/userUnCheck.8859a1e949e05a85cf68d7e439733efe.svg";
export { ForwardRef as ReactComponent };